export default "__VITE_ASSET__BvGfl7yU__"